/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2CrossLocation/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2CrossLocation({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2CrossLocation",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2CrossLocation.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 12"
 style={{'--as-1-ZW87Ig': alignSelf,'--mt-2-ZW87Ig': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZW87Ig': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZW87Ig': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZW87Ig': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZW87Ig': opacity,'--w-10-ZW87Ig': typeof width === 'number' ? `${width}px` : width,'--h-11-ZW87Ig': typeof height === 'number' ? `${height}px` : height,'--f-12-ZW87Ig': fill,'--a-7-ZW87Ig': isAnimated ? animation : "none",'--sd-8-ZW87Ig': isAnimated ? strokeDashoffset : 0,'--sd-9-ZW87Ig': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2CrossLocation.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.488 0C2.67 0 .398 2.327.398 5.181c0 1.704.844 3.173 1.794 4.29.954 1.121 2.05 1.932 2.64 2.328.399.268.914.268 1.314 0 .588-.396 1.685-1.207 2.638-2.328.95-1.117 1.795-2.586 1.795-4.29C10.58 2.327 8.308 0 5.49 0zM4.417 3c0-.12.096-.215.214-.215h1.715c.118 0 .214.096.214.214v1.072h1.072c.118 0 .214.096.214.214V6a.214.214 0 01-.214.214H6.56v1.072a.214.214 0 01-.214.214H4.63a.214.214 0 01-.214-.214V6.214H3.345A.214.214 0 013.13 6V4.285c0-.118.096-.214.215-.214h1.072V2.999z"
 style={{'--f-12-ZW87Ig': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}